import {BaseContainerModel} from '../base-container.model';
import { bl_inv_current_company_stock_balance_RowClass } from '../../dbschema';

export class CurrentCompanyStockBalanceContainerModel extends BaseContainerModel {
  bl_inv_current_company_stock_balance: bl_inv_current_company_stock_balance_RowClass
}
